import { useCallback } from 'react';

import { useNotIdle } from '@/lostHooks/use-not-idle/useNotIdle';

const KEEP_ALIVE_EVENTS: (keyof HTMLElementEventMap)[] = [
  'click',
  'keydown',
  'scroll',
  'touchstart',
];

type UseSessionKeepAliveOptions = {
  onActivity: () => void | Promise<void>;
  enabled?: boolean;
};

export const useSessionKeepAlive = ({
  onActivity,
  enabled = true,
}: UseSessionKeepAliveOptions) => {
  const handleKeepAlive = useCallback(() => {
    void onActivity();
  }, [onActivity]);

  useNotIdle(handleKeepAlive, {
    events: KEEP_ALIVE_EVENTS,
    enabled,
  });
};
